import axios from 'axios';
import config from '../config';
const qs = require('querystring');

export const getAssets = async ({
    page = 0,
    sort,
    filters,
    csv = false,
} = {}) => {
    const sortParam =
        sort && sort.sortBy && sort.sortDirection
            ? `&sort=${sort.sortBy}&direction=${sort.sortDirection}`
            : '';
    const filterParam = filters
        ? `&${filters
              .filter((x) => x)
              .map((filter) => `${filter.name}=${filter.value}`)
              .join('&')}`
        : '';
    const url = `${config.apiUrl}/api/assets?page=${page}${sortParam}${filterParam}`;
    if (csv) {
        return `${url}&csv=true`;
    } else {
        const {
            data: { results },
        } = await axios(url, {
            withCredentials: true,
        });
        return results;
    }
};
// Legacy endpoint
export const deleteAssets = async ({ ids = [] } = {}) => {
    const result = await axios.post(
        `${config.baseV1Url}/jobs/remove-bulk`,
        qs.stringify({ ids, dummy: '' }),
        {
            headers: {
                'Content-Type':
                    'application/x-www-form-urlencoded; charset=UTF-8',
            },
            withCredentials: true,
        },
    );
    //todo handle errors
};
export const reprocessAssets = async ({
    ids = [],
    percent,
    selectedPercent,
    template,
    selectedTemplate,
    buyLinks,
    onix,
    preferences,
    selectedUser,
    selectedImprint,
    duplicate,
} = {}) => {
    const formData = {};
    if (percent) formData['socialPercent'] = selectedPercent;
    if (template) formData['ingestTemplate'] = selectedTemplate;
    if (buyLinks) formData['update_buy_links'] = 'on';
    if (onix) formData['add_onix_details'] = 'on';
    if (preferences) formData['add_preferences'] = 'on';
    if (duplicate) formData['duplicate'] = 'on';
    if (selectedUser) formData['submitterId'] = selectedUser.value;
    if (selectedImprint) formData['imprintId'] = selectedImprint.value;
    const formsDataString = qs.stringify({
        formData: JSON.stringify(formData),
    });
    const idsString = qs.stringify({ ids, dummy: '' });
    const paramsString = `${formsDataString}&${idsString}`;
    const result = await axios.post(
        `${config.baseV1Url}/jobs/reprocess-bulk`,
        paramsString,
        {
            headers: {
                'Content-Type':
                    'application/x-www-form-urlencoded; charset=UTF-8',
            },
            withCredentials: true,
        },
    );
    //todo handle errors
};

export const activateAssets = async ({ ids = [] } = {}) => {
    const result = await axios.post(
        `${config.baseV1Url}/jobs/activate-bulk`,
        qs.stringify({ ids, dummy: '' }),
        {
            headers: {
                'Content-Type':
                    'application/x-www-form-urlencoded; charset=UTF-8',
            },
            withCredentials: true,
        },
    );
};
export const deActivateAssets = async ({ ids = [] } = {}) => {
    const result = await axios.post(
        `${config.baseV1Url}/jobs/deactivate-bulk`,
        qs.stringify({ ids, dummy: '' }),
        {
            headers: {
                'Content-Type':
                    'application/x-www-form-urlencoded; charset=UTF-8',
            },
            withCredentials: true,
        },
    );
    //todo handle errors
};
export const searchAssets = async (query) => {
    const url = `${config.apiUrl}/api/assets/search?query=${query}`;
    const {
        data: { results },
    } = await axios(url, {
        withCredentials: true,
    });
    return results;
};
